// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2PWNw","image":"Header_image__26dS2","name":"Header_name__2Umv-","info":"Header_info__38Sy-","infoRow":"Header_infoRow__19lEp"};